import React, {Component} from 'react';
import UnitModal from '../Modal/UnitModal';
import Gallery from "../Modal/Gallery";
import SVG from 'react-inlinesvg';
import {Link} from 'react-router-dom'
import {connect} from "react-redux";
import {fetchUnit, publishToJira, updateToJira, deleteJira, downloadFromS3, addToFavorites} from "../../actions/unitActions";
import './Unit.css';
import whiteStar from '../../assets/icons/StarIconInUse.png';
import greyStar from '../../assets/icons/StarIconDisabled.png';
import downloadArrow from '../../assets/Download.png';
import PublishedModal from '../Modal/Published';
import Loading from '../Shared/Loading';
import AccessControl from '../../utils/AccessControl';
import moment from 'moment';
import lock from "../../assets/lock-480x480.png";
import ToolTips from "../Shared/ToolTips";
import trash from "../../assets/trash-outline.svg"
import ThumbnailDeviceFrame from "../Shared/ThumbnailDeviceFrame";
import CampaignModalContainer from "../Modal/campaignModalContainer";
import {getCreativeInfo} from "../../actions/campaignActions";
// import Notification from "../Shared/Notification";

class Unit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: {
                unit: false,
                gallery: false
            },
            gallery_id: false,
            pub: false,
            error: false,
            err_message: "",
            delete: false,
            multi_banners: false,
            jira_published: false,
            jira_message: false,
            jira_updated: false,
            jira_id: "",
            socket_status: false,
            jiraIsCreating: false
        }
    };

    componentDidMount() {
        this.props.dispatch(fetchUnit(this.props.type, this.props.match.params.id)).then(()=>{
            this.multiBannersCheck();
            if(this.props.permission === false){
                this.props.history.push('/unauthorized');
            }
        })
        this.props.dispatch(getCreativeInfo());
        // let that = this;
        // socket.on("message", function(data) {
        //     console.log("data ", data)
        //     that.setState({
        //         jira_message: data.message,
        //         jira_published: data.published,
        //         jira_updated: data.updated,
        //         jira_id: data.jira,
        //     })
        // })
        // socket.on("status", function(data) {
        //     that.setState({
        //         socket_status: data.text,
        //     })
        // })
    }
    componentWillUnmount() {
        // socket.off("message");
        // socket.off("status");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.unit.display_banner_type !== prevProps.unit.display_banner_type || this.props.unit.meta !== prevProps.unit.meta) {
            this.multiBannersCheck();
        }
        if(this.props.unit !== prevProps.unit){
            if (this.props.unit.published === 1){
                this.setState({jira_published : true})
            }
            if (this.props.unit.published === -1){
                this.setState({jira_published : -1})
            }
        }
    }


    publishToJira = () =>{
        if(this.props.user.email !== undefined){
            // socket.emit('join', {email: this.props.user.email});
        }
        let data = {
            id: this.props.unit.id,
            cid: this.props.campaign.id
        };
        if(this.props.unit.EPIC_ID === null || this.props.unit.EPIC_ID === ""){
            this.setState({pub: true, error: true, err_message: "Please add EPIC ID to creative before publishing to JIRA."})
        }else{
            this.props.dispatch(publishToJira(data))
            this.setState({pub: true, jira_published: -1})
        }
    }
    updateJira = () => {
        let data = {
            id: this.props.unit.id,
            cid: this.props.campaign.id
        };
        if(this.props.unit.jira_id === null || this.props.jira_id === ""){
            this.setState({pub: true, error: true, err_message: "Error: No JIRA ID on creative. "})
        }else{
            this.props.dispatch(updateToJira(data))
            this.setState({pub: true})
        }
    }
    deleteJira = () => {
        if(this.props.unit.jira_id === null || this.props.unit.jira_id === undefined){
            let id =  this.state.jira_id;
            this.setState({
                pub: true,
                error: true,
                jira_id: id
            })
        }else{
            let jira_id = this.props.unit.jira_id;
            let mock_id = this.props.unit.id;
            this.props.dispatch(deleteJira(mock_id, jira_id));
            this.setState({
                delete: false,
                jira_message: false,
                jira_published: false,
                jira_id: false
            })
        }

    }
    deleteModal = () => {
        this.setState({
            pub: true,
            delete: true
        })
    }
    toggleModal = (type, show) => {
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };
    closePublished = () => {
        this.props.dispatch(fetchUnit('mock', this.props.unit.id))
        this.setState({
            pub: false
        })
    }
    galleryInfo = (id) => {
        this.setState({
            gallery_id: id
        })
    }
    downloadAll = () => {
        this.props.dispatch(downloadFromS3(this.props.unit.id, this.props.campaign.name));
    }
    filterFuncs = () => {
        if(this.props.unit.creative_type_id === 1 || this.props.unit.creative_type_id === 7 || this.props.unit.creative_type_id === 8){
            return this.props.unit.functionalities.map((f, i) => {
                if(f.name !== "Expandable" && f.name !== "Interstitial"){
                    return (<li className="functionality-list-item"
                                 key={i}>{f.name}</li>)
                }
            })
        }else{
            return this.props.unit.functionalities.map((f, i) => {
                return (<li className="functionality-list-item"
                                  key={i}>{f.name}</li>)
            })
        }
    }
    multiBannersCheck = () => {
        let multi = false;
        if(this.props.unit.meta !== undefined && this.props.unit.meta[0].meta_value === "static" || this.props.unit.display_banner_type === 'standard'){
            multi = true;
        }
        this.setState({ multi_banners: multi})
    }
    addToFavorites = () => {
        let data = {
            unit_id:  this.props.unit.id,
            unit_type: this.props.type
        }
        this.props.dispatch(addToFavorites(data));
    }
    unitJiraProcess = () => {
        if(this.props.unit !== undefined){
            if(this.state.jira_published === -1){
                return(
                    <div className="unit-campaign-sub-value">
                        <span>Ticket is being processed...</span>
                    </div>
                )
            } else if(this.state.jira_published || this.state.jira_updated || this.props.unit.jira_id !== null){
                return(
                    <div className="unit-campaign-sub-value">
                        <span><a href={this.state.jira_id !== "" ?  "https://adtheorent.atlassian.net/browse/" + this.state.jira_id :  "https://adtheorent.atlassian.net/browse/"+ this.props.unit.jira_id } target="_blank" rel="noopener noreferrer">JIRA Ticket</a>
                            <div className={this.props.type === "live" ? "btn-publish-container-inner edit--right-align" : "btn-publish-container-inner"}>
                                <div className="jira--btn--container">
                                    {this.showPublishedButton()}
                                    {this.props.unit.published === 1 || this.state.jira_published === true ?
                                        <div className="jira--btns" onClick={() => this.deleteModal()}> <SVG src={trash}/></div> : ""}
                                </div>
                            </div>
                        </span>
                    </div>
                )
            }else{
                return(
                    <div className="unit-campaign-sub-value">
                        {this.showPublishedButton()}
                    </div>
                )
            }
        }
        return (<div></div>);
    }
    showPublishedButton = () => {
        if(this.state.jira_published === -1 || this.state.jira_published === true || this.props.unit.published === -1 || this.props.unit.published === 1){
            return(<span></span>)
        }else{
            return(
                <span className="publish jira--btns-pub" onClick={() => this.publishToJira()}>Publish to Jira</span>
            )
        }
        // return (<div></div>);
    }
    displayComponent = () => {
        const campaign = this.props.creative_info;
        if(this.state.showModal.unit){
            return(
                <CampaignModalContainer
                    toggleModal={this.toggleModal}
                    create={false}
                    modal={this.state.showModal}
                    inputOptions={this.props.creative_info.meta}
                    stages='unitPage'
                    campaign={this.props.campaign}
                    fullUserFlow={false}
                    unit={this.props.unit}
                    user={this.props.user}
                />
            )
        }
        return (<div></div>);
    }


    render() {
        const type = this.props.type;
        const {unit, campaign, verticals} = this.props;

        return (
            <div className="unit-page">
                {this.displayComponent()}
                <table>
                    <tbody>
                    {this.state.showModal.gallery && <Gallery
                        toggleModal={this.toggleModal}
                        unit={this.props.unit}
                        active_id={this.state.gallery_id}
                        gallery_Info={this.galleryInfo}
                    />}
                    </tbody>
                </table>
                {this.props.loading ? <Loading>Error</Loading> :
                    <div className={`unit-container unit-container--${unit.thumbnail_device_id} ${type}`}>
                        <div className="left-column">
                            <div className="left-column-inner">
                                <ThumbnailDeviceFrame
                                        unitType={type}
                                        adImage={unit.thumbnail}
                                        thumbnailDeviceId={unit.thumbnail_device_id}
                                />
                            </div>
                        </div>
                        <div className="right-column">
                            <div className="unit-campaign-header">
                                <div className="unit-campaign-subHeader">
                                    <Link to={`/brand/${campaign.brand_id}`}>
                                        <u>{campaign.brand_name}{campaign.hide_brand === 1 ? <span id="lock-container"><ToolTips content="Hidden Brand" data="hb"><img src={lock} alt="brand is hidden"/></ToolTips></span> : ""}</u>
                                    </Link>
                                    <span className="unit-divider"> | </span>
                                    <Link to={`/campaign/${campaign.id}`}>
                                        <u>{campaign.name}</u>
                                    </Link>
                                </div>
                                <div className="unit-campaign-subHeader">
                                    <h2>
                                        {unit.unit_type}
                                    </h2>
                                </div>
                                <div>
                                    {/*<p className="unit-campaign-sub-heading">Functionality</p>*/}
                                    <ul className="unit-campaign-sub-value">
                                        {this.filterFuncs()}
                                    </ul>
                                </div>
                                <div className="creative-sub-wrapper">
                                    <div className="favorite-btn-container">
                                        {type === 'mock' && unit.animated === "true" ?  <span className="mocked-icon"></span> : 
                                            type === 'live' ? <span className="live-icon"></span> : <span className="mock-icon"></span>
                                        }
                                        <AccessControl
                                            userPermissions={this.props.user.roles}
                                            allowedPermissions={['guest', 'analytics']}
                                        >
                                            {unit.favorite !== undefined && (
                                                <div className="favorite-btn unit-fav-btn">
                                                    <div className="tool-wrapper">
                                                        <ToolTips content={"Best in Class"}>
                                                            <img src={this.props.favorite ? whiteStar: greyStar} className="grey-star" alt="grey-star" style={{width: "24px", height: "22px", marginTop: "1px"}}/>
                                                        </ToolTips>
                                                    </div>
                                                </div>
                                            )}
                                        </AccessControl>
                                        <AccessControl
                                            userPermissions={this.props.user.roles}
                                            allowedPermissions={['editor', 'admin']}
                                        >
                                            <button onClick={this.addToFavorites} className="favorite-btn unit-fav-btn">
                                                <div className="tool-wrapper">
                                                    <ToolTips content={this.props.favorite ? "Remove from Best in Class": "Add to Best in Class"}>
                                                        <img src={this.props.favorite ? whiteStar: greyStar} className="grey-star" alt="grey-star" style={{width: "24px", height: "22px"}}/>
                                                    </ToolTips>
                                                </div>
                                            </button>
                                        </AccessControl>
                                    </div>
                                    {type === 'live' && this.state.multi_banners && unit.s3_links.length > 0  &&
                                        <React.Fragment>
                                            <div className="unit-banner-container">
                                                {/*<p className="unit-campaign-sub-heading">Banners</p>*/}
                                                <div className={unit.s3_links.length > 8 ? "scrollable-links unit-campaign-sub-value" : "unit-campaign-sub-value"}>
                                                    <ul className="unstyled list--link attached clearfix">
                                                        {unit.s3_links.map((links, i) => {
                                                            return (
                                                                <li key={i}>
                                                                 <div className="attached_links"  onClick={() => {this.toggleModal('gallery', true); this.galleryInfo(links.id)}}>
                                                                     <div className="banner-images">{links.ad_size}{links.note !== '' && links.note != null && <span className="demo-links-notes"> {links.note}</span>}</div>
                                                                     {/*<SVG src={modalIcon}/>*/}
                                                                 </div>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                            {/*<div className="unit-campaign-sub-wrapper"> <button className="button button--download" onClick={() => this.downloadAll()}>Zip File</button></div>*/}
                                        </React.Fragment>
                                    }
                                    {type === 'live' && !this.state.multi_banners && unit.demo_links.length > 0 &&
                                        <div className="unit-banner-container" style={unit.ppt_location != null ? {paddingLeft: '49px'} : {}}>
                                            <div className={unit.demo_links.length > 8 ? "scrollable-links unit-campaign-sub-value" : "unit-campaign-sub-value"}>
                                                <ul className="unstyled list--link">
                                                    {unit.demo_links.map((links, i) => {
                                                        return (
                                                            <li key={i}>
                                                                <div className="attached_links">
                                                                    <a href={links.url} target="_blank" rel="noopener noreferrer">
                                                                        <div>{links.demo_type} {links.notes !== '' && links.notes != null && <span className="demo-links-notes">{links.notes}</span>}</div>
                                                                    </a>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                    {unit.ppt_location != null &&
                                            <div className="unit-campaign-sub-value">
                                                <ul className="unstyled list--link">
                                                    <li className={`${type === 'live' ? 'mock--ppt' : ''}`} >
                                                        <span className="button button--download"><a href={unit.ppt_location} target="_blank" rel="noopener noreferrer">PPT File <img
                                                            className="ppt--download-btn" src={downloadArrow} alt=""/></a></span>
                                                    </li>
                                                </ul>
                                            </div>
                                    }

                                </div>
                            </div>
                            <div className="unit-box-info">
                                <div className="unit-campaign-sub-wrapper verticals">
                                    <p className="unit-campaign-sub-heading">Vertical</p>
                                    <p className="unit-campaign-sub-value">{typeof campaign.subcategory === 'undefined' || campaign.subcategory === "" ? (campaign.verticals) : (campaign.verticals +", "+campaign.subcategory)}</p>
                                </div>
                                <div className="unit-campaign-sub-wrapper">
                                    <p className="unit-campaign-sub-heading">Designer</p>
                                    <p className="unit-campaign-sub-value">{unit.designer}</p>
                                </div>
                                <div className="unit-campaign-sub-wrapper">
                                    <p className="unit-campaign-sub-heading">Seller</p>
                                    <p className="unit-campaign-sub-value">{campaign.seller}</p>
                                </div>
                                <div className="unit-campaign-sub-wrapper">
                                    <p className="unit-campaign-sub-heading">Date</p>
                                    <p className="unit-campaign-sub-value">{moment(unit.date).format('MMMM YYYY')}</p>
                                </div>
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['editor', 'admin']}>
                                    <div className="unit-campaign-sub-wrapper">
                                            <p className="unit-campaign-sub-heading">Links</p>
                                            {type === 'live' && unit.jira_url != "" &&
                                                <span className="links--live"><a href={unit.jira_url} target="_blank">JIRA Ticket</a></span>
                                            }
                                            {type === 'live' && unit.celtra_url != "" && unit.unit_type !== 'Display' && unit.creative_type_id !== 500 &&
                                                <span className="links--live"><a href={unit.celtra_url} target="_blank">CELTRA</a></span>
                                            }
                                            {type === 'mock' && unit.creative_assets_url !== null &&
                                                <div>
                                                    <div className="unit-campaign-sub-value">
                                                        <span className="links--live"><a href={unit.creative_assets_url} target="_blank" rel="noopener noreferrer">Creative Assets</a></span>
                                                    </div>
                                                </div>
                                            }
                                        {type === 'mock' &&
                                            <div className="notification-container links--live">
                                                <div>
                                                    {this.unitJiraProcess()}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </AccessControl>
                            </div>
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['editor', 'admin']}
                            >
                                <div className={type === "live" ? "btn-publish-container edit--right-align" : "btn-publish-container" }>
                                    {type === 'mock' &&
                                        <div className="jira--btn--container " style={{opacity: 0}}>
                                            JIRA Actions: {this.showPublishedButton()}
                                            {this.props.unit.published === 1 || this.state.jira_published === true ? <button className="jira--btns"  onClick={()=>this.deleteModal()}>Delete</button> : ""}
                                        </div>
                                    }
                                    <div>
                                        <button className="button button--blue" onClick={() => {this.toggleModal('unit', true)}}>Edit Entry</button>
                                    </div>
                                </div>
                            </AccessControl>
                        </div>
                        {this.state.pub &&
                            <PublishedModal
                                message={this.props.message}
                                delete={this.state.delete}
                                deleteJira={()=>this.deleteJira()}
                                error={this.state.error}
                                url={this.props.jira_url}
                                unitId={this.props.unit.id}
                                err_message={this.state.err_message}
                                close={()=>this.closePublished()}/>
                        }
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creative_info: state.campaign,
    ...state.unit,
    user: state.user,
    permission: state.unit.permission
});

export default connect(mapStateToProps)(Unit);
